import React from 'react';

const PlaylistScreen = () => <div className="PlaylistScreen" />;

export default PlaylistScreen;
